module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/PT G5-0279b8f93cb13d94b95a196f849bfd42.gif";